module.exports = __webpack_public_path__ + "0a6b6b8b515aeeb490b5bc0793b84838.png";